<template>
  <div class="background">
    <div class="position">
      <div class="container_LS03">
        <div class="btn-prev" v-if="pageWidth > 1024">
          <ButtonIcon
            :bgColor="`#e6efff`"
            :iconUrl="prev_icon"
            :size="1"
            @click="onPrev()"
          />
        </div>
        <div class="contain">
          <div
            v-if="checkDataLength == 0"
            style="padding-top: 15%; padding-bottom: 17%"
          >
            <h1 style="color: #89abe6">
              You have not been learned in this chapter yet.
            </h1>
            <h3 style="text-align: left">Go back to learn first.</h3>
          </div>
          <div
            class="block"
            v-for="(value, index) in cardContent"
            :key="index"
            v-else
          >
            <div class="card">
              <div class="box_question">
                <div>
                  <img
                    style="width: 100%; height: 100%"
                    :src="'https://mdl.mfu.ac.th/' + value.media[0].url"
                  />
                </div>
                <div class="line_question"></div>

                <div class="header_text">
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                    v-for="(value, index) in value.title[3].value.split('//')"
                    :key="index"
                  >
                    <a class="fontPinyin header_text_pinyin">{{ value }}</a>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                    v-for="(value, index) in value.title[2].value.split('//')"
                    :key="index"
                  >
                    <a class="fontChinese header_text_title">{{ value }}</a>
                  </div>
                  <br />
                  <button
                    style="margin-top: 10px"
                    type="button"
                    class="btn btn-circle btn-lg"
                    @click="createSoundObject(value)"
                  >
                    <i class="fas fa-bullhorn"></i>
                  </button>
                </div>
                <div class="line_question"></div>
                <div class="meaning_text">
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <a>{{ value.message[1].value }}</a>
                  </div>
                  <a>{{ checkLanguage(value.description) }} </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-exit" v-if="pageWidth >= 1024">
          <ButtonIcon
            :bgColor="`#ed8e91`"
            :iconUrl="close_icon"
            :size="1"
            @click="onClose"
          />
        </div>
      </div>
    </div>
    <div v-if="pageWidth <= 1024" class="btn-close-container">
      <div class="buttonBack" @click="onPrev()">Back</div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/elements/Buttons/ButtonIcon';
import Card from '@/components/elements/Card';
import '../../../assets/scss/chinessStyle2.scss';
import {mapGetters} from 'vuex';

export default {
  components: {ButtonIcon, Card},
  name: 'TEMPLATE',
  props: {},
  data() {
    return {
      prev_icon: '/icons/arrow-left.svg',
      close_icon: '/icons/close.svg',
      Card_img:
        'https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-image-512.png',
      pageWidth: window.innerWidth,
      cardContent: Array,
      language: this.$store.getters['language/getLanguage'],
      checkDataLength: Number,
      soundObject: Object,
      code: '',
    };
  },
  methods: {
    onPrev: function () {
      this.$router.push('/v4/LS04/1');
    },
    onClose: function () {
      this.$router.push('/v4/LS01/1');
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language.toUpperCase()) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error!!');
        }
      } else {
        console.log('change language is error!!');
      }
    },
    createSoundObject(val) {
      try {
        this.soundObject.pause();
        this.soundObject = new Audio(
          process.env.VUE_APP_URL_SOUND + val.media[1].url,
        );
        this.play();
      } catch (error) {
        this.soundObject = new Audio(
          process.env.VUE_APP_URL_SOUND + val.media[1].url,
        );
        this.play();
      }
    },
    play() {
      this.soundObject.play();
    },
    onLoadData() {
      const codeTemplate = 'LS02-' + this.$route.params.id;
      this.$store.dispatch('v3/fetchTemplateByCode', codeTemplate);
    },
  },
  computed: {
    ...mapGetters({
      getFlipCardData: 'template/getFlipCardData',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
      v3LessonFlipCard: 'v3-data/v3LessonFlipCard',
    }),
  },
  watch: {
    v3LessonFlipCard: function (value) {
      console.log('madafuka', value);
      this.checkDataLength = value.length;
      let store = [];
      for (let i = 0; i < value.length; i++) {
        for (let j = 0; j < value[i].content.item.length; j++) {
          store.push(value[i].content.item[j]);
        }
      }
      this.cardContent = store;
      console.log(this.cardContent);
    },
    getTemplatev3: function (val) {
      if (!val) return;
      console.log(val);
    },

    getFlipCardData: function (value) {
      this.checkDataLength = value.data.length;
      let store = [];
      for (let i = 0; i < value.data.length; i++) {
        for (let j = 0; j < value.data[i].template.content.item.length; j++) {
          store.push(value.data[i].template.content.item[j]);
        }
      }
      this.cardContent = store;
      console.log(this.cardContent);
    },
    storeLanguage: function (val) {
      this.language = val;
    },
  },
  created() {
    console.log('pageWidth', window.innerWidth);
    this.code = this.$store.state.necessary.learningCourse;
  },
  mounted() {
    // let payload = {
    //   // code: "605418cb883ae722ba1b0c5f",
    //   code: this.code,
    //   chapterCode: 'LS02-' + this.$route.params.id,
    // };
    let payload = {
      // code: "605418cb883ae722ba1b0c5f",
      courseId: this.code,
      codeItem: 'LS02-' + this.$route.params.id + '-2',
    };
    this.$store.dispatch('v3-data/v3LessonFlipCard', payload);
    // this.$store.dispatch('template/fetchFlipCardChinese2', payload);
    // this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.background {
  background-color: #e6efff;
}
.container_LS03 {
  margin-top: 5%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
.contain {
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  width: 90%;
  padding: 0;
  align-items: center;
}
.position {
  margin-top: 3%;
  display: flex;
  padding-bottom: 5%;
}
.block {
  display: flex;
  margin: 1%;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  transition: 0.3s;
}

.btn-exit {
  width: 60px;
  height: 60px;
  margin-left: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  right: 3%;
}
.buttonBack {
  outline: none;
  border: none;
  width: 100%;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 10px;
  font-size: 16px;
  color: white;
  margin-left: 25%;
  margin-right: 25%;
  width: 50%;
  background-color: #89abe6;
}
.btn-prev {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  left: 17%;
}
.btn-close-container {
  text-align: center;
  padding-bottom: 10%;
}
.text-instructor-container {
  padding-top: 5%;
  padding-bottom: 10%;
}
.text-instructor-container {
  color: red;
  font-size: 16px;
}
.card {
  border-radius: 20px; /* 5px rounded corners */
  border: 0px solid;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: auto;
  padding: 20px;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.35);
}
.img_card_component {
  width: 100%;
  height: 100%;
}
.box_question {
  width: 100%;
  height: auto;
  margin-top: 3%;
  margin-bottom: 3%;
  display: flex;
  background-color: #f2f2f2;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.header_text_pinyin {
  color: #89abe6;
  font-size: 24px;
  margin-left: 2%;
  margin-right: 2%;
}
.header_text_title {
  color: #89abe6;
  font-size: 45px;
  color: #000000;
  margin-left: 2%;
  margin-right: 2%;
}
.header_text {
  position: relative;
  text-align: center;
  margin-top: 10px;
  width: 100%;
}
.line_question {
  margin-top: 9%;
  margin-bottom: 4%;
  height: 2px;
  width: 60%;
  background-color: #d9d9d9;
}
.meaning_text a:nth-child(1) {
  color: #89abe6;
  font-size: 20px;
  margin-left: 2%;
  margin-right: 2%;
}
.meaning_text a:nth-child(2) {
  color: #89abe6;
  font-size: 24px;
  color: #000000;
  margin-left: 2%;
  margin-right: 2%;
}
.meaning_text {
  position: relative;
  text-align: center;
  width: 100%;
  margin-bottom: 3%;
}
.btn-circle {
  width: 40px;
  height: 40px;
  padding: 6px 0px;
  border-radius: 30px;
  text-align: center;
  font-size: 16px;
  line-height: 1.42857;
  background-color: #1d5bd7;
  color: white;
}
// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .container_LS03 {
    padding-top: 20%;
    margin-top: 0%;
    justify-content: center;
  }
  .card {
    width: 320px;
  }
}
@media only screen and (min-width: 700px) and (max-width: 821px) {
  .container_LS03 {
    justify-content: center;

    padding-top: 15%;
  }
  .block {
    width: 300px;
    margin: 2%;
    margin-bottom: 4%;
  }
  .buttonBack {
    margin-left: 33%;
    margin-right: 25%;
    width: 35%;
  }

  .btn-prev {
    width: 50px;
    height: 50px;
    padding: 10px;
    left: 10%;
  }
  .bg-image {
    height: 700px;
  }
  .button_setting {
    width: 150px;
    height: 50px;
  }
  .btn-exit {
    width: 65px;
    height: 65px;
    padding: 10px;
    right: 2%;
    font-size: 30px;
  }
}
@media screen and (max-width: 1366px) and (min-width: 1024px) {
  .container_LS03 {
    justify-content: center;

    padding-top: 5%;
  }
  .buttonBack {
    outline: none;
    border: none;
    width: 100%;
    text-align: center;
    padding-top: 12px;
    padding-bottom: 12px;
    border-radius: 10px;
    font-size: 16px;
    color: white;
    margin-left: 40%;
    width: 20%;
    background-color: #89abe6;
  }
  .contain {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    width: 90%;
    padding: 0;
    align-items: center;
  }
  .block {
    width: 24%;
    margin-top: 1%;
  }

  .btn-prev {
    width: 80px;
    height: 80px;
    padding: 10px;
    left: 10%;
  }
  .bg-image {
    height: 700px;
  }

  .btn-exit {
    width: 80px;
    height: 80px;
    padding: 10px;
    right: 3%;
    font-size: 30px;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1700px) {
  .contain {
    width: 45%;
    justify-content: center;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .contain {
    width: 50%;
    justify-content: center;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1400px) {
  .contain {
    width: 55%;
    justify-content: center;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1800px) {
  .contain {
    width: 100%;
    justify-content: center;
  }
  .btn-prev {
    width: 80px;
    height: 80px;
    padding: 10px;
    left: 5%;
  }
  .btn-exit {
    right: 1%;
    top: 10%;
  }
  .btn-prev {
    left: 0%;
    top: 10%;
  }
}
</style>
